import { IFilterItemV2 } from "#src/commonV2/Table/Filter/types";
import { DeviceAssetType } from "#src/services/endpoint/enums";
import i18next from "i18next";

const fixedTFunc = i18next.getFixedT(null, "endpoint", "devices");

export const assetTypeFilterItems = [
  {
    key: "company-owned",
    getLabel: () => fixedTFunc("table.filter.assetType.companyOwned"),
    value: DeviceAssetType.COMPANY_OWNED,
  },
  {
    key: "personal",
    getLabel: () => fixedTFunc("table.filter.assetType.personal"),
    value: DeviceAssetType.PERSONAL,
  },
];

export const softwareTypeItems: IFilterItemV2[] = [
  {
    key: "app",
    value: "apps,programs",
    getLabel: () => fixedTFunc("software.typeFilter.app"),
  },
  {
    key: "browser_extension",
    value: "firefox_addons,chrome_extensions,ie_extensions",
    getLabel: () => fixedTFunc("software.typeFilter.browser_extension"),
  },
  {
    key: "vscode_extension",
    value: "vscode_extensions",
    getLabel: () => fixedTFunc("software.typeFilter.vscode_extension"),
  },
  {
    key: "python_package",
    value: "python_packages",
    getLabel: () => fixedTFunc("software.typeFilter.python_package"),
  },
  {
    key: "npm_package",
    value: "npm_packages",
    getLabel: () => fixedTFunc("software.typeFilter.npm_package"),
  },
  {
    key: "deb_package",
    value: "deb_packages",
    getLabel: () => fixedTFunc("software.typeFilter.deb_package"),
  },
  {
    key: "homebrew_package",
    value: "homebrew_packages",
    getLabel: () => fixedTFunc("software.typeFilter.homebrew_package"),
  },
];

export const backupEnabledFilterItems: IFilterItemV2[] = [
  {
    key: "yes",
    value: "1",
    getLabel: () => fixedTFunc("table.filter.backup.yes"),
    leftIcon: <span className="h-2 w-2 m-0.5 bg-success-v2 rounded-full" />,
  },
  {
    key: "no",
    value: "0",
    getLabel: () => fixedTFunc("table.filter.backup.no"),
    leftIcon: <span className="h-2 w-2 m-0.5 bg-error-v2 rounded-full" />,
  },
];
